// extracted by mini-css-extract-plugin
module.exports = {"Secondary":"SliceZone_Secondary__8JQsy","slicePr":"SliceZone_slicePr__5EOzr","fancyTitle":"SliceZone_fancyTitle__I0Od0"};